import React from 'react';
import { Link, Route, Switch } from 'react-router-dom';

import Content from '../../../../_psb/layout/Content';
import SubHeader from '../../../../_psb/layout/sub-header/SubHeader';
import Search from '../../../../components/form/Search';
import { connect } from 'react-redux';
import { setSearchValueAction } from '../../../../modules/artisanJobs/Actions';
import { searchValueSelector } from '../../../../modules/artisanJobs/Selectors';
import getLangData from '../../../../utils/getLangData';
import CompanyList from './CompanyList';
import AdminsRoute from '../../../router/AdminsRoute';

const artisanjobs = props => {
  const { searchValue, setSearchValue } = props;
  return (
    <>
      {/* <SubHeader>
        <Switch></Switch>
      </SubHeader> */}
      <Content>
        <Switch>
          <AdminsRoute exact path='/jobs/company/' component={CompanyList} />
        </Switch>
      </Content>
    </>
  );
};

const mapStateToProps = state => ({
  searchValue: searchValueSelector(state)
});

const mapDispatchToProps = {
  setSearchValue: setSearchValueAction
};

export default connect(mapStateToProps, mapDispatchToProps)(artisanjobs);
